import React from 'react';
import Swal from 'sweetalert2';
import { Link, Redirect } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faFileContract, faFilePdf, faFilter, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        nit_tercero: '',
        empresa_grupo: '',
        email_tercero: '',
        ano_certificado: '',
        tipo_certificado: '',
        pdfDGBase64: null,
        empresas_grupo: [],
        ano_folders: [],
        tipo_certificados: [],
        errores: []
    }

    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }

    validateEmail = (email) => {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regex.test(email);
    }

    cargarAnos = (e) => {
        Swal.showLoading();
        const { nit_tercero } = this.state;
        var empresa_grupo = e.target.value;
        this.setState({ ano_folders:[], tipo_certificados: [] })
        authAxios.get("formulario/cargar_anos_certificados/" + empresa_grupo + "/" + nit_tercero)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({
                    datosCargados: true,
                    ano_folders: datosRespuesta.data.ano_folders });
                Swal.close();
            })
            .catch(console.log());
    }

    cargarTipoCertificados = (e) => {
        Swal.showLoading();
        const { nit_tercero } = this.state;
        var ano_certificado = e.target.value;
        var empresa_grupo = document.getElementById('empresa_grupo').value;
        this.setState({ tipo_certificados: [] });
        authAxios.get("formulario/cargar_certificados_generados/" + empresa_grupo + "/" + nit_tercero + "/" + ano_certificado)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({
                    datosCargados: true,
                    tipo_certificados: datosRespuesta.data.tipo_certificados });
                Swal.close();
            })
            .catch(console.log());
    }

    viewFile = async (fileName, tipoCertificado) => {
        Swal.showLoading();
        let id_empresa = window.localStorage.getItem('id_empresa');
        var ano_certificado = document.getElementById('ano_certificado').value;
        var empresa_grupo = document.getElementById('empresa_grupo').value;
        this.setState({ pdfDGBase64: null });
        await authAxios.get("formulario/view_certificate/" + empresa_grupo + "/" + id_empresa + "/" + ano_certificado + "/" + tipoCertificado + "/" + fileName, { responseType: 'blob' })
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                const pdfBase64 = URL.createObjectURL(datosRespuesta.data);
                this.setState({ pdfDGBase64: pdfBase64 });
                Swal.close();
            })
            .catch(console.log);
    }

    cancelarConsulta = () => {
        this.setState({
            empresa_grupo: '',
            ano_certificado: '',
            ano_folders: [],
            tipo_certificados: [],
        });
        document.getElementById("empresa_grupo").selectedIndex = "0";
    }

    generarCertificado = (e) => {
        e.preventDefault();
        const { nit_tercero, empresa_grupo, ano_certificado, tipo_certificado, email_tercero } = this.state;
        var errores = [];
        if (!nit_tercero) { errores.push("error_nit_tercero"); }
        if (!empresa_grupo) { errores.push("error_empresa_grupo"); }
        if (!ano_certificado) { errores.push("error_ano_certificado"); }
        if (!tipo_certificado) { errores.push("error_tipo_certificado"); }
        if (!email_tercero) { errores.push("error_email_tercero"); }
        if (!this.validateEmail(email_tercero)) {
            errores.push("error_email_tercero");
            Swal.fire({
                title: 'Formularios',
                text: 'El correo electrónico no tiene el formato aceptado. Favor verificar Información.',
                icon: 'error',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {
                    errores.push("error_email_tercero");
                }
            })
        }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            nit_tercero: nit_tercero,
            empresa_grupo: empresa_grupo,
            ano_certificado: ano_certificado,
            tipo_certificado: tipo_certificado,
            email_tercero: email_tercero,
            id_usuario: window.localStorage.getItem('id_usuario')
        }
        Swal.showLoading();
        authAxios.post("formulario/enviar_certificado", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Consulta Certificados!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterConsultarCertificados");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Consulta Certificados!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    
    componentDidMount() {
        const timeout = window.localStorage.getItem('timeout');
        // alert("Now: " + Date.now() + " - TimeOut: " + timeout);
        if (Date.now() > timeout) {
            // alert("Entra");
            window.location.href = "/";
            window.localStorage.clear();
            Swal.fire({
                title: 'Formularios',
                text: 'Sesión Expirada',
                icon: 'error',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = "/";
                    window.localStorage.clear();
                }
            })
        }
        const date = new Date();
        const newDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        Swal.showLoading();
        let id_empresa = window.localStorage.getItem('id_empresa');
        authAxios.get("formulario/nit/" + id_empresa)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({
                    datosCargados: true,
                    nit_certificado: datosRespuesta.data.nit });
            })
            .catch(console.log());
        authAxios.get("formulario/empresas_grupo")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({
                    datosCargados: true,
                    empresas_grupo: datosRespuesta.data });
                Swal.close();
            })
            .catch(console.log());
    }
    render() {
        const { load, nit_tercero, email_tercero, empresas_grupo, ano_folders, tipo_certificados, pdfDGBase64, errores } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>GENERAR NUEVO CERTIFICADO</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.generarCertificado}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="nit_tercero">NIT</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input className={((this.verificarError("error_identificacion")) ? "is-invalid" : "border border-info") + " form-control form-control-sm"}
                                                            maxLength={20} type="number" name="nit_tercero" id="nit_tercero" value={nit_tercero} min="1" placeholder="NIT TERCERO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Nit Tercero</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className="col-md-4">
                                                    <label htmlFor="empresa_grupo">Empresa Emisora</label>
                                                    <select name="empresa_grupo"
                                                        id="empresa_grupo"
                                                        className={((this.verificarError("error_empresa_grupo")) ? "is-invalid" : "border border-info") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.cambioValor(e);
                                                            this.cargarAnos(e);
                                                        }}>
                                                            <option value="">Seleccione la Empresa Emisora</option>
                                                            {
                                                                empresas_grupo.map((itemEmpresasGrupo) => (
                                                                    <option key={itemEmpresasGrupo.id} value={itemEmpresasGrupo.codigo}>{itemEmpresasGrupo.nombre}</option>
                                                                ))
                                                            }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Empresa Emisora</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="ano_certificado">Año</label>
                                                    <select name="ano_certificado"
                                                        id="ano_certificado"
                                                        className={((this.verificarError("error_ano_certificado")) ? "is-invalid" : "border border-info") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.cambioValor(e);
                                                            this.cargarTipoCertificados(e);
                                                        }}>
                                                            <option value="">Seleccione el Año</option>
                                                            {
                                                                (() => {
                                                                    const folders_ano = [];
                                                                    for (let i=0; i < ano_folders.length; i++) {
                                                                        const folder_name = ano_folders[i];
                                                                        folders_ano.push(
                                                                            <option key={i} value={folder_name}>{folder_name}</option>
                                                                        );
                                                                    }
                                                                    return folders_ano;
                                                                })()
                                                            }
                                                            
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Año Certificado</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="tipo_certificado">Tipo Certificado</label>
                                                    <select name="tipo_certificado"
                                                        id="tipo_certificado"
                                                        className={((this.verificarError("error_tipo_certificado")) ? "is-invalid" : "border border-info") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.cambioValor(e);
                                                        }}>
                                                            <option value="">Seleccione el T. Certificado</option>
                                                            {
                                                                (() => {
                                                                    const folders_tipo_certificados = [];
                                                                    for (let i=0; i < tipo_certificados.length; i++) {
                                                                        const folder_name = tipo_certificados[i];
                                                                        folders_tipo_certificados.push(
                                                                            <option key={i} value={folder_name}>{folder_name}</option>
                                                                        );
                                                                    }
                                                                    return folders_tipo_certificados;
                                                                })()
                                                            }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Certificado</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="email_tercero">Email Tercero</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input className={((this.verificarError("error_email_tercero")) ? "is-invalid" : "border border-info") + " form-control form-control-sm"}
                                                            maxLength={150} type="text" name="email_tercero" id="email_tercero" value={email_tercero} placeholder="EMAIL TERCERO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Email Tercero</small>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='row'>
                                                <div className='col-xl-12 text-center'>
                                                    <div className="btn-group" role="group" aria-label="">
                                                        <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faFileContract} />&nbsp;&nbsp;Generar Certificado</button>&nbsp;&nbsp;
                                                        <Link className="btn btn-danger btn-sm" to={"/MasterConsultarCertificados"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-xl-8">
                                            <div className="card">
                                                <div className="card-header text-center">
                                                    CERTIFICADOS DISPONIBLES
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <nav>
                                                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                                {
                                                                    (() => {
                                                                        const tabTipoCertificado = [];
                                                                        for (let i=0; i < tipo_certificados.length; i++) {
                                                                            const tipoCertificadoData = tipo_certificados[i];
                                                                            if (i == 0) {
                                                                                tabTipoCertificado.push(
                                                                                    <button className="nav-link active" id={"nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase() + "-tab"} data-bs-toggle="tab" data-bs-target={"#nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase()} type="button" role="tab" aria-controls={"nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase()} aria-selected="false">{tipoCertificadoData.tipo_certificado[0]}</button>
                                                                                );
                                                                            } else {
                                                                                tabTipoCertificado.push(
                                                                                    <button className="nav-link" id={"nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase() + "-tab"} data-bs-toggle="tab" data-bs-target={"#nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase()} type="button" role="tab" aria-controls={"nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase()} aria-selected="false">{tipoCertificadoData.tipo_certificado[0]}</button>
                                                                                );
                                                                            }
                                                                        }
                                                                        return tabTipoCertificado;
                                                                    })()
                                                                }
                                                            </div>
                                                        </nav>
                                                        <div className="tab-content" id="nav-tabContent">
                                                            {
                                                                (() => {
                                                                    const divTipoCertificado = [];
                                                                    for (let i=0; i < tipo_certificados.length; i++) {
                                                                        const tdDocuments = [];
                                                                        const tipoCertificadoData = tipo_certificados[i];
                                                                        if (i == 0) {
                                                                            divTipoCertificado.push(
                                                                                <>
                                                                                    <div className="tab-pane fade show active" id={"nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase()} role="tabpanel" aria-labelledby={"nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase() + "-tab"}>
                                                                                        <div style={{ marginTop: 15 }} className="row">
                                                                                            <div className="col-xl-12">
                                                                                                <div className='row g-3'>
                                                                                                    <div className="col-md-12">
                                                                                                        <table className="table table-hover table-condensed table-sm">
                                                                                                            <thead className="thead-inverse">
                                                                                                                <tr>
                                                                                                                    <th className="align-middle">NOMBRE DOCUMENTO</th>
                                                                                                                    <th className="align-middle">OPCIONES</th>
                                                                                                                </tr>
                                                                                                            </thead>
                                                                                                            <tbody>
                                                                                                                {
                                                                                                                    (() => {
                                                                                                                        for (let j=0; j<tipoCertificadoData.documents.length; j++) {
                                                                                                                            const documentsData = tipoCertificadoData.documents[j];
                                                                                                                            tdDocuments.push(
                                                                                                                                <>
                                                                                                                                    <tr>
                                                                                                                                        <td key={j}>{documentsData}</td>
                                                                                                                                        <td>
                                                                                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                                                                                <button
                                                                                                                                                    type="button"
                                                                                                                                                    className="btn btn-secondary btn-sm"
                                                                                                                                                    data-bs-toggle='modal'
                                                                                                                                                    data-bs-target="#PDFFileModal"
                                                                                                                                                    slot='end'
                                                                                                                                                    onClick={() =>
                                                                                                                                                        this.viewFile(documentsData, tipoCertificadoData.tipo_certificado[0])
                                                                                                                                                    }
                                                                                                                                                >
                                                                                                                                                    <FontAwesomeIcon icon={faFilePdf} />
                                                                                                                                                </button>
                                                                                                                                            </div>
                                                                                                                                        </td>
                                                                                                                                    </tr>
                                                                                                                                </>
                                                                                                                            )
                                                                                                                        }
                                                                                                                        return tdDocuments;
                                                                                                                    })()
                                                                                                                }
                                                                                                            </tbody>
                                                                                                        </table>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        } else {
                                                                            divTipoCertificado.push(
                                                                                <>
                                                                                    <div className='tab-pane fade' id={"nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase()} role="tabpanel" aria-labelledby={"nav-" + tipoCertificadoData.tipo_certificado[0].toLowerCase() + "-tab"}>
                                                                                        <div style={{ marginTop: 15 }} className="row">
                                                                                            <div className="col-xl-12">
                                                                                                <div className='row g-3'>
                                                                                                    <div className="col-md-12">
                                                                                                        <table className="table table-hover table-condensed table-sm">
                                                                                                            <thead className="thead-inverse">
                                                                                                                <tr>
                                                                                                                    <th className="align-middle">NOMBRE DOCUMENTO</th>
                                                                                                                    <th className="align-middle">OPCIONES</th>
                                                                                                                </tr>
                                                                                                            </thead>
                                                                                                            <tbody>
                                                                                                                {
                                                                                                                    (() => {
                                                                                                                        for (let j=0; j<tipoCertificadoData.documents.length; j++) {
                                                                                                                            const documentsData = tipoCertificadoData.documents[j];
                                                                                                                            tdDocuments.push(
                                                                                                                                <>
                                                                                                                                    <tr>
                                                                                                                                        <td key={j}>{documentsData}</td>
                                                                                                                                        <td>
                                                                                                                                            <div className="btn-group" role="group" aria-label="">
                                                                                                                                                <button
                                                                                                                                                    type="button"
                                                                                                                                                    className="btn btn-secondary btn-sm"
                                                                                                                                                    data-bs-toggle='modal'
                                                                                                                                                    data-bs-target="#PDFFileModal"
                                                                                                                                                    slot='end'
                                                                                                                                                    onClick={() =>
                                                                                                                                                        this.viewFile(documentsData, tipoCertificadoData.tipo_certificado[0])
                                                                                                                                                    }
                                                                                                                                                >
                                                                                                                                                    <FontAwesomeIcon icon={faFilePdf} />
                                                                                                                                                </button>
                                                                                                                                            </div>
                                                                                                                                        </td>
                                                                                                                                    </tr>
                                                                                                                                </>
                                                                                                                            )
                                                                                                                        }
                                                                                                                        return tdDocuments;
                                                                                                                    })()
                                                                                                                }
                                                                                                            </tbody>
                                                                                                        </table>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        }
                                                                        
                                                                    }
                                                                    return divTipoCertificado;
                                                                })()
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                </form>
                            </div>
                            {/* <div className="card-footer text-muted">
                                &nbsp;
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PDFFileModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PDFFileModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PDFFileModalLabel">Certificado Tributario</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12' style={{marginBottom: '30px'}}>
                                        {/* <iframe style={{ width: '100%', height: '600px'}} src={`data:application/pdf;base64,${pdfDGBase64}`}></iframe> */}
                                        <iframe style={{ width: '100%', height: '600px'}} src={pdfDGBase64}></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;